import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';
import { getSessionData, redirectAfterLogin } from '../util/helper';

const routes = [
  {
    path: '/',
    redirect: () => {
      const role = getSessionData('role');

      return redirectAfterLogin(role);
    },
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue'),
      },
      {
        path: '/icons',
        name: 'icons',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Icons.vue'),
      },
      {
        path: '/profile',
        name: 'profile',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Pages/MyProfile.vue'),
      },
      {
        path: '/maps',
        name: 'maps',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/GoogleMaps.vue'),
      },
      {
        path: '/users',
        name: 'users',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Users/ListUsers.vue'),
      },
      {
        path: '/settings',
        name: 'settings',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Pages/Settings.vue'),
      },
      {
        path: '/add-user',
        name: 'addUser',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Users/AddUser.vue'),
      },
      {
        path: '/parameters',
        name: 'parameters',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Parameters/ListParameters.vue'
          ),
      },
      {
        path: '/add-parameter',
        name: 'addParameter',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Parameters/AddParameter.vue'
          ),
      },
      {
        path: '/documents',
        name: 'documents',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Documents/ListDocuments.vue'
          ),
      },
      {
        path: '/add-document',
        name: 'addDocument',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Documents/AddDocument.vue'
          ),
      },
      {
        path: '/orders',
        name: 'orders',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Orders/ListOrders.vue'
          ),
      },
      {
        path: '/add-order',
        name: 'addOrder',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Orders/AddOrder.vue'),
      },
      {
        path: '/add-invoice',
        name: 'addInvoice',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Invoices/AddInvoice.vue'
          ),
      },
      {
        path: '/questions',
        name: 'questions',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Questions/ListQuestions.vue'
          ),
      },
      {
        path: '/add-question',
        name: 'addQuestion',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Questions/AddQuestion.vue'
          ),
      },
      {
        path: '/action',
        name: 'action',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Orders/Action.vue'),
      },
      {
        path: '/order/log',
        name: 'orderLog',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Orders/LogOrder.vue'),
      },
      {
        path: '/order/payment-proof',
        name: 'uploadPaymentProof',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Orders/UploadPaymentProof.vue'
          ),
      },
      {
        path: '/order/feedback',
        name: 'feedback',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Orders/Feedback.vue'),
      },
      {
        path: '/job-approval',
        name: 'jobApproval',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Orders/JobApproval.vue'
          ),
      },
    ],
  },
  {
    path: '/',
    redirect: 'landing',
    component: AuthLayout,
    children: [
      {
        path: '/landing',
        name: 'landing',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Pages/Landing.vue'),
      },
      {
        path: '/tracking',
        name: 'tracking',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Pages/Tracking.vue'),
      },
      {
        path: '/tracking-order',
        name: 'tracking-order',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Pages/DetailOrderTracking.vue'
          ),
      },
      {
        path: '/about-us',
        name: 'about-us',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Pages/AboutUs.vue'),
      },
      {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Pages/PrivacyPolicy.vue'
          ),
      },
      {
        path: '/our-services',
        name: 'our-services',
        component: () =>
          import(
            /* webpackChunkName: "demo" */ '../views/Pages/OurServices.vue'
          ),
      },
      {
        path: '/login',
        name: 'login',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue'),
      },
      {
        path: '/register',
        name: 'register',
        component: () =>
          import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue'),
      },

      { path: '*', component: NotFound },
    ],
  },
];

export default routes;
